// ANCHOR React
import { useEffect, useLayoutEffect } from 'react';
import { IS_SERVER } from '../status';

export const useIsomorphicEffect = IS_SERVER
  ? useEffect
  : useLayoutEffect;
